var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKanerikaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 461.9 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill: url(#linear-gradient);      }      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {        stroke-width: 0px;      }      .cls-2 {        fill: url(#radial-gradient);      }      .cls-3 {        fill: #1664df;      }      .cls-4 {        fill: url(#radial-gradient-2);      }      .cls-5 {        fill: url(#radial-gradient-3);      }    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 350.4,
    cy: 17.75,
    fx: 350.4,
    fy: 17.75,
    r: 35.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f36494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ffb95c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 36.79,
    y1: 1.37,
    x2: 88.9,
    y2: 87.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c4dc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#884ec6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7d51c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6b56cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#515dd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3067db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#166fe2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#1a5bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#185dc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1761d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1663dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1664df"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1.54,
    cy: 27.71,
    fx: 1.54,
    fy: 27.71,
    r: 81.01,
    gradientTransform: "translate(25.81 19.77) rotate(75.34) scale(1 .92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#8c4dc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f36494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffb95c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 14.3,
    cy: 74.19,
    fx: 14.3,
    fy: 74.19,
    r: 42.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c63144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ff6a46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbd62"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.54,79.32c-2.52,1.32-5.18,2.13-8,2.43-2.82.3-5.3.45-7.46.45-4.31,0-8.09-1.17-11.32-3.5-3.23-2.34-4.85-6.2-4.85-11.59,0-5.03,1.47-8.62,4.4-10.78,2.93-2.16,6.68-3.59,11.23-4.31.6,0,1.32-.09,2.16-.27.84-.18,1.8-.33,2.87-.45,5.27-.72,7.91-2.27,7.91-4.67,0-1.8-.93-2.96-2.79-3.5-1.86-.54-3.57-.81-5.12-.81-1.68,0-3.17.24-4.49.72-1.32.48-2.28,1.38-2.88,2.7h-12.04c.48-3.71,2.16-6.77,5.03-9.17,3.23-2.75,7.85-4.13,13.84-4.13,6.71,0,11.74,1.14,15.1,3.41,3.47,2.4,5.21,5.75,5.21,10.06v16.35c0,4.79-.87,8.54-2.6,11.23-1.74,2.7-3.81,4.64-6.2,5.84ZM197.67,57.22c-1.68.84-4.02,1.62-7.01,2.34l-4.13.9c-2.16.6-3.72,1.38-4.67,2.34-.84,1.32-1.26,2.64-1.26,3.96,0,1.79.54,3.23,1.62,4.31,1.08.96,2.63,1.44,4.67,1.44,3.35,0,5.99-.96,7.91-2.88,1.91-1.91,2.88-4.55,2.88-7.91v-4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.51,82.2h-6.41c-1.83,0-3.32-.58-4.48-1.74-1.16-1.16-1.74-2.65-1.74-4.48v-24.89c0-2.93-.89-5.06-2.65-6.4-1.77-1.34-3.75-2.01-5.95-2.01s-4.15.67-5.86,2.01c-1.71,1.34-2.56,3.47-2.56,6.4v31.11h-12.81v-28.55c0-8.3,2.16-13.85,6.5-16.65s9.12-4.33,14.37-4.58c5.37,0,10.31,1.41,14.83,4.21,4.51,2.81,6.77,8.48,6.77,17.02v28.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M299.52,66.56h8.98c-1.32,5.03-3.84,8.87-7.55,11.5-3.72,2.76-8.39,4.13-14.02,4.13-6.83,0-12.16-2.22-15.99-6.65-3.84-4.31-5.75-10.48-5.75-18.51s1.86-13.66,5.57-17.97c3.83-4.43,9.16-6.65,15.99-6.65,7.19,0,12.76,2.16,16.71,6.47,3.83,4.43,5.75,10.6,5.75,18.51v1.98c0,.6-.06,1.02-.18,1.26h-31.09c.12,3.72,1.02,6.47,2.7,8.27,1.55,1.92,3.89,2.88,7.01,2.88,2.03,0,3.78-.42,5.21-1.26.36-.12.69-.33.99-.63.3-.3.63-.63.99-.99.12-.36.57-.84,1.35-1.44.78-.6,1.89-.9,3.32-.9ZM277.96,52.55h18.33c-.24-3.23-1.08-5.63-2.52-7.19-1.56-1.67-3.78-2.51-6.65-2.51-2.64,0-4.79.84-6.47,2.51-1.68,1.68-2.58,4.08-2.7,7.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.5,32.42h-15.75l-15.89,18.35v-26.76c0-1.64-.64-3.06-1.85-4.31-1.28-1.25-2.78-1.89-4.53-1.89h-6.73v64.38h13.11v-18.88c0-1,.68-1.75,2.07-2.24,1.35-.5,2.99.93,4.85,4.28l9.19,16.85h15.71l-17.96-30.68,17.78-19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M332.29,33.74c-3.17.86-5.95,2.24-8.3,4.1-2.49,2-4.49,4.67-5.91,7.98-1.43,3.28-2.14,7.38-2.14,12.26v24.12h13.11v-25.62c0-3.78.86-6.48,2.6-8.27,1.75-1.75,4.42-2.6,8.05-2.6h4.31v-13.29h-1.89c-3.35,0-6.63.43-9.83,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357.94,31.99h-7.16v50.24h14v-43.44c0-1.89-.68-3.49-2.03-4.81-1.32-1.35-2.92-2-4.81-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.95,21.76c0,1.75-.61,3.24-1.85,4.49-1.25,1.25-2.74,1.89-4.53,1.89h-6.73v-10.3h13.11v3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M399.75,51.47l17.78-19.1h-15.75l-15.89,18.35v-26.76c0-1.64-.64-3.06-1.89-4.31-1.25-1.25-2.74-1.89-4.49-1.89h-6.73v64.42h13.11v-18.92c0-1,.68-1.75,2.07-2.24,1.35-.5,2.99.93,4.85,4.28l9.19,16.85h15.71l-17.96-30.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M453.09,79.32c-2.52,1.32-5.18,2.13-8,2.43-2.82.3-5.3.45-7.46.45-4.31,0-8.09-1.17-11.32-3.5-3.23-2.34-4.85-6.2-4.85-11.59,0-5.03,1.47-8.62,4.4-10.78,2.93-2.16,6.68-3.59,11.23-4.31.6,0,1.32-.09,2.16-.27.84-.18,1.8-.33,2.87-.45,5.27-.72,7.91-2.27,7.91-4.67,0-1.8-.93-2.96-2.79-3.5-1.86-.54-3.57-.81-5.12-.81-1.68,0-3.17.24-4.49.72-1.32.48-2.28,1.38-2.88,2.7h-12.04c.48-3.71,2.16-6.77,5.03-9.17,3.23-2.75,7.85-4.13,13.84-4.13,6.71,0,11.74,1.14,15.1,3.41,3.47,2.4,5.21,5.75,5.21,10.06v16.35c0,4.79-.87,8.54-2.6,11.23-1.74,2.7-3.81,4.64-6.2,5.84ZM450.22,57.22c-1.68.84-4.02,1.62-7.01,2.34l-4.13.9c-2.16.6-3.72,1.38-4.67,2.34-.84,1.32-1.26,2.64-1.26,3.96,0,1.79.54,3.23,1.62,4.31,1.08.96,2.63,1.44,4.67,1.44,3.35,0,5.99-.96,7.91-2.88,1.91-1.91,2.88-4.55,2.88-7.91v-4.49Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.35,49.48l.04,39.94c0,2.67,2.9,4.34,5.21,3l34.57-20.01c1.07-.62,1.73-1.77,1.73-3.01l-.04-39.94q-.16-5.68-5.22-9.06L52.04.46c-1.07-.62-2.4-.62-3.47,0L13.99,20.48c-2.31,1.34-2.31,4.68,0,6.01l34.62,19.94c1.07.62,1.74,1.81,1.74,3.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.9,99.08l-.05.03c-2.06,1.19-4.6,1.19-6.67,0l-15.49-8.94-19.36-11.18c-2.06-1.19-3.33-3.39-3.33-5.77v-40.23c0-2.38,1.27-4.59,3.33-5.77,1.07-.62,2.21-.9,3.33-.9,3.48,0,6.67,2.78,6.67,6.67v32.48c0,2.38,1.27,4.59,3.33,5.77l28.24,16.31c4.44,2.57,4.44,8.98,0,11.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.9,99.08l-.05.03c-2.06,1.18-4.6,1.18-6.67,0l-15.49-8.92c-11.46-10.42-9.37-26.94-9.37-26.94v2.3c0,2.38,1.27,4.57,3.33,5.76l28.24,16.26c4.44,2.56,4.44,8.96,0,11.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanerikaLogo);
export default __webpack_public_path__ + "static/media/kanerika-logo.f87c1996a861fcaa2e8c7012380f67a6.svg";
export { ForwardRef as ReactComponent };